import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { getComponentFactoryCode, getComponentSearchCode } from '../../admin/repositories';
import { getComponentFailureCodeList, getComponentsystemEffectList } from '../repositories';
import { CancelOnlyModal } from '../../shared/components/modals/cancel-only-modal';
import InputWithFaIcon from '../../shared/components/labeled-input-with-fa-icon';
import LabeledInput from '../../shared/components/labeled-input';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFieldValue } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

class ComponentFunctionCodeDetails extends Component {

    state = {
        confirmTitle: '',
        confirmIsOpen: false,
        editableFields: {},
        componentSearchCodes: [],
        componentDropdownList: [],
        componentFailureCodeList: [],
        componentsystemEffectList: [],
    }

    defaultProp = {
        componentFunctionCodeName: this.props.claimPartDetails.component !== undefined ? getFieldValue( this.props.claimPartDetails.component.componentFunctionCodeName ) : '',

        componentGroupCode: this.props.claimPartDetails.component !== undefined ? getFieldValue( this.props.claimPartDetails.component.componentGroupCode ) : '',

        componentFactoryCode: this.props.claimPartDetails.component !== undefined ? getFieldValue( this.props.claimPartDetails.component.componentFactoryCode ) : '',

        componentSystemEffect: this.props.claimPartDetails.component !== undefined ? getFieldValue( this.props.claimPartDetails.component.componentSystemEffect ) : '',

        componentFailureMode: this.props.claimPartDetails.component !== undefined ? getFieldValue( this.props.claimPartDetails.component.componentFailureMode ) : '',

        componentGroupDesignation: this.props.claimPartDetails.component !== undefined ? getFieldValue( this.props.claimPartDetails.component.componentGroupDesignation ) : '',
    }

    componentWillMount = () => {

        getComponentFactoryCode().then( response => {

            const componentFnCodeDropdwnList = [];
            response.forEach( seriesList => {

                componentFnCodeDropdwnList.push( {
                    factoryCode: seriesList.factoryCode,
                    factoryDescription: `${seriesList.factoryCode} - ${seriesList.factoryDescription}`,
                } );

            } );
            this.setState( {
                componentDropdownList: componentFnCodeDropdwnList,
            } );

        } ).catch( () => {} );


        getComponentFailureCodeList().then( response => {

            const componentFailureCodes = [];

            response.forEach( seriesList => {

                componentFailureCodes.push( {
                    failureModeCode: seriesList.failureModeCode,
                    description: `${seriesList.failureModeCode} - ${seriesList.description}`,
                } );

            } );

            this.setState( {

                componentFailureCodeList: componentFailureCodes,

            } );

        } ).catch( () => { } );

        getComponentsystemEffectList().then( response => {

            const componentsystemEffects = [];

            response.forEach( seriesList => {

                componentsystemEffects.push( {
                    systemEffectCode: seriesList.systemEffectCode,
                    systemEffectDescription: `${seriesList.systemEffectCode} - ${seriesList.systemEffectDescription}`,
                } );

            } );

            this.setState( {

                componentsystemEffectList: componentsystemEffects,

            } );

        } ).catch( () => { } );

        this.setState( {
            editableFields: this.defaultProp,
        } );

    }

    componentWillReceiveProps = nextProps => {

        const obj = {

            componentFunctionCodeName: getFieldValue( nextProps.claimPartDetails.component
                .componentFunctionCodeName ),

            componentGroupCode: getFieldValue( nextProps.claimPartDetails.component
                .componentGroupCode ),

            componentFactoryCode: getFieldValue( nextProps.claimPartDetails.component
                .componentFactoryCode ),

            componentSystemEffect: getFieldValue( nextProps.claimPartDetails.component
                .componentSystemEffect ),

            componentFailureMode: getFieldValue( nextProps.claimPartDetails.component
                .componentFailureMode ),

            componentGroupDesignation: getFieldValue( nextProps.claimPartDetails.component
                .componentGroupDesignation ),
        };
        this.defaultProp = obj;
        this.setState( {
            editableFields: obj,
        } );

    }

    onEditBtnClicked = () => {

        this.props.enableEditCmp( 'Component Codes' );

    }

    onCancelBtnClicked = () => {

        if ( this.props.enableEditCmp( 'Component Codes' ) ) {

            this.setState( {
                editableFields: this.defaultProp,

            } );

        }

    }

    handleConfirmClose = () => {

        this.setState( {
            confirmIsOpen: false,
        } );

    }

    handleUpdate=val => {

        const updatedVal = { ...this.state.editableFields };
        updatedVal[val.target.name] = val.target.value;

        this.setState( {
            editableFields: updatedVal,
        } );

    }

    handleOnChange=( name, val ) => {

        const updatedVal = { ...this.state.editableFields };
        updatedVal[name] = val;

        this.setState( {
            editableFields: updatedVal,
        } );

    }

    handleClinkFunctionCode = () => {

        const obj = {
            componentfactoryText: this.props.claimPartDetails.component.componentFactoryCode,
            componentPartNoText: this.props.claimPartDetails.partNumber.corrected,
        };
        this.props.increaseCounter();
        getComponentSearchCode( obj ).then( response => {

            this.setState( {
                componentSearchCodes: response,
                confirmIsOpen: true,
                confirmTitle: 'Select Component Function Code',
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    updateFunctionCode = e => {

        const obj = { ...this.state.editableFields };
        obj.componentGroupCode = e.componentGroupCode;
        obj.componentFunctionCodeName = e.componentFunctionCodeName;
        this.setState( {
            editableFields: obj,
        } );
        this.handleConfirmClose();

    }

    onSaveBtnClicked = () => {

        let isEdited = false;
        const updatedData = {};

        updatedData.componentFactory = this.state.editableFields.componentFactoryCode;
        isEdited = true;
        // if ( this.state.editableFields.componentFactoryCode
        //     !== this.props.claimPartDetails.component.componentFactoryCode ) {

        //     updatedData.componentFactory = this.state.editableFields.componentFactoryCode;
        //     isEdited = true;

        // }

        if ( this.state.editableFields.componentFunctionCodeName
            !== this.props.claimPartDetails.component.componentFunctionCodeName ) {

            updatedData.componentFunctionCode = this.state.editableFields.componentFunctionCodeName;
            isEdited = true;

        }

        if ( this.state.editableFields.componentGroupCode
            !== this.props.claimPartDetails.component.componentGroupCode ) {

            updatedData.componentGroupCode = this.state.editableFields.componentGroupCode;
            isEdited = true;

        }

        if ( this.state.editableFields.componentSystemEffect
            !== this.props.claimPartDetails.component.componentSystemEffect ) {

            updatedData.componentSystemEffect = this.state.editableFields.componentSystemEffect;
            isEdited = true;

        }

        if ( this.state.editableFields.componentFailureMode
            !== this.props.claimPartDetails.component.componentFailureMode ) {

            updatedData.componentFailureModeCode = this.state.editableFields.componentFailureMode;
            isEdited = true;

        }

        if ( this.state.editableFields.componentGroupDesignation
            !== this.props.claimPartDetails.component.componentGroupDesignation ) {

            updatedData.componentGroupDesignation
            = this.state.editableFields.componentGroupDesignation;
            isEdited = true;

        }
        // console.log( updatedData );
        if ( isEdited ) this.props.updateClaim( 'component-function-code', updatedData );
        this.onCancelBtnClicked();

    }

    render () {

        return (

            <div className="basic-claim">
                <section className="component-codes">
                    <header>
                        {this.props.isComponentEdit && (
                            <h4 className="page-header">
                                <i title="Edit" className={`fa fa-edit ${!this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onEditBtnClicked} />
                                <i className={`fa fa-save ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onSaveBtnClicked} />
                                <i className={`fa fa-remove ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onCancelBtnClicked} />
                            </h4>
                        )}
                    </header>
                    <div className="rows">

                        <div className="four-cols">
                            <InputWithFaIcon
                                className="basic-claim-info"
                                name="componentFunctionCodeName"
                                isEditable={this.props.isEdit}
                                label="Component Function Code Name"
                                onChange={this.handleUpdate}
                                value={this.state.editableFields.componentFunctionCodeName}
                                iconClassName="fa fa-binoculars"
                                type="text"
                                onIconClick={this.handleClinkFunctionCode}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="componentGroupCode"
                                isEditable={this.props.isEdit}
                                label="Component Group Code "
                                value={this.state.editableFields.componentGroupCode}
                                onChange={this.handleUpdate}
                            />
                        </div>

                        <div className="four-cols drop-down">
                            {!this.props.isEdit && (
                                <div>
                                    <label>Component Factory</label>
                                    <span className="drpdwn-labels">{this.state.editableFields.componentFactoryCode}</span>
                                </div>
                            )}
                            {this.props.isEdit && (
                                <OptionsDropDown
                                    className={this.props.isEdit ? 'non-editable' : ''}
                                    isPlaceholderTranslated={true}
                                    label="Component Factory"
                                    optionDisplayAttributes={['factoryDescription']}
                                    optionKey="factoryCode"
                                    options={this.state.componentDropdownList}
                                    onChange={this.handleOnChange.bind( this.props, 'componentFactoryCode' )}
                                    placeholder=""
                                    selectedValue={this.state.editableFields.componentFactoryCode}
                                />
                            )}
                        </div>

                        <div className="four-cols drop-down">
                            {!this.props.isEdit && (
                                <div>
                                    <label>Component System Effect</label>
                                    <span className="drpdwn-labels">{this.state.editableFields.componentSystemEffect}</span>
                                </div>
                            )}
                            {this.props.isEdit && (
                                <OptionsDropDown
                                    className={this.props.isEdit ? 'non-editable' : ''}
                                    isPlaceholderTranslated={true}
                                    label="Component System Effect"
                                    optionDisplayAttributes={['systemEffectDescription']}
                                    optionKey="systemEffectCode"
                                    options={this.state.componentsystemEffectList}
                                    onChange={this.handleOnChange.bind( this.props, 'componentSystemEffect' )}
                                    placeholder=""
                                    selectedValue={this.state.editableFields.componentSystemEffect}
                                />
                            )}
                        </div>
                    </div>

                    <div className="rows">
                        <div className="four-cols drop-down">
                            {!this.props.isEdit && (
                                <div>
                                    <label>Component Failure Mode Code</label>
                                    <span className="drpdwn-labels">{this.state.editableFields.componentFailureMode}</span>
                                </div>
                            )}
                            {this.props.isEdit && (
                                <OptionsDropDown
                                    className={this.props.isEdit ? 'non-editable' : ''}
                                    isPlaceholderTranslated={true}
                                    label="Component Failure Mode Code"
                                    optionDisplayAttributes={['description']}
                                    optionKey="failureModeCode"
                                    options={this.state.componentFailureCodeList}
                                    onChange={this.handleOnChange.bind( this.props, 'componentFailureMode' )}
                                    placeholder=""
                                    selectedValue={this.state.editableFields.componentFailureMode}
                                />
                            )}
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="componentGroupDesignation"
                                isEditable={this.props.isEdit}
                                label="Component Group Designation"
                                value={this.state.editableFields.componentGroupDesignation}
                                onChange={this.handleUpdate}
                            />
                        </div>

                    </div>
                </section>
                <CancelOnlyModal
                    body={(
                        <div>
                            <span className="part-number">
                                Component Function Codes for
                                Part Number: {this.props.claimPartDetails.partNumber.corrected}
                            </span>
                            <table className="function-code-table">
                                <tr>
                                    <th>Component Function Code</th>
                                    <th>Manufacturing Factory</th>
                                    <th>Component Group Code</th>
                                </tr>
                                {this.state.componentSearchCodes.map( item => (
                                    <tr>
                                        <td>
                                            <button
                                                className="btn-link"
                                                type="button"
                                                onClick={this.updateFunctionCode.bind( this, item )}
                                            >                      {item.componentFunctionCodeName}
                                            </button>
                                        </td>
                                        <td>{item.manufacturingFactoryCode}</td>
                                        <td>{item.componentGroupCode}</td>
                                    </tr>
                                ) )}

                            </table>
                        </div>
                    )}
                    className="function-code-popup"
                    header={this.state.confirmTitle}
                    isOpen={this.state.confirmIsOpen}
                    onCancel={this.handleConfirmClose}
                    onHide={this.handleConfirmClose}
                />
            </div>

        );

    }

}
ComponentFunctionCodeDetails.displayName = 'ComponentFunctionCodeDetails';
ComponentFunctionCodeDetails.propTypes = {
    claimPartDetails: PropTypes.object.isRequired,
    updateClaim: PropTypes.func.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( ComponentFunctionCodeDetails );
